import { render, staticRenderFns } from "./SubBranches.vue?vue&type=template&id=c3b68078"
import script from "./SubBranches.vue?vue&type=script&lang=js"
export * from "./SubBranches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports